export function normalizedValue(value?: string | string[]): string[] {
  if (typeof value === 'string') {
    return value
      ? value
          .split(',')
          .map((v) => v.trim())
          .filter(Boolean)
      : [];
  }
  return value || [];
}
